// src/components/auth/components/ImgOlslm/ImgOlslmQ2.tsx
import React from "react";
import { TreeSelect, Tooltip } from "antd";
import styled from "styled-components";
import { loginImages } from "../../constants/LoginImg";

const { TreeNode } = TreeSelect;

const ImagePreview = styled.img`
  max-width: 50px;
  max-height: 50px;
  border-radius: 4px;
  margin-right: 8px;
`;

interface ImageData {
  id: string; // e.g., "693.12.87.3399"
  index: number; // loginImages.images index
  group: string; // e.g., "1-10"
  number: number; // e.g., 1, 2, ...
}

const imageData: ImageData[] = [
  { id: "693.12.87.3399", index: 220, group: "1-10", number: 1 },
  { id: "694.2.88.3399", index: 221, group: "1-10", number: 2 },
  { id: "695.10.89.3399", index: 221, group: "1-10", number: 3 },
  { id: "1791.1.89.3402", index: 223, group: "1-10", number: 3 },
  { id: "695.1.90.3399", index: 224, group: "1-10", number: 4 },
  { id: "1792.1.90.3402", index: 225, group: "1-10", number: 4 },
  { id: "1793.1.91.3402", index: 226, group: "1-10", number: 5 },
  { id: "698.1.92.3399", index: 227, group: "1-10", number: 6 },
  { id: "1794.1.92.3402", index: 228, group: "1-10", number: 6 },
  { id: "699.1.93.3399", index: 229, group: "1-10", number: 7 },
  { id: "1795.1.93.3402", index: 230, group: "1-10", number: 7 },
  { id: "1796.1.94.3402", index: 231, group: "1-10", number: 8 },
  { id: "2162.1.95.3403", index: 232, group: "1-10", number: 9 },
  { id: "702.10.96.3399", index: 233, group: "1-10", number: 10 },
  { id: "703.1.97.3399", index: 234, group: "11-20", number: 11 },
  { id: "704.1.98.3399", index: 235, group: "11-20", number: 12 },
  { id: "705.1.99.3399", index: 236, group: "11-20", number: 13 },
  { id: "1436.1.99.3401", index: 237, group: "11-20", number: 13 },
  { id: "706.1.100.3399", index: 238, group: "11-20", number: 14 },
  { id: "1437.1.100.3401", index: 239, group: "11-20", number: 14 },
  { id: "1438.1.101.3401", index: 240, group: "11-20", number: 15 },
  { id: "1803.1.101.3402", index: 241, group: "11-20", number: 15 },
  { id: "1439.1.102.3401", index: 242, group: "11-20", number: 16 },
  { id: "1804.1.102.3402", index: 243, group: "11-20", number: 16 },
  { id: "1805.1.103.3402", index: 244, group: "11-20", number: 17 },
  { id: "1441.1.104.3401", index: 245, group: "11-20", number: 18 },
  { id: "711.1.105.3399", index: 246, group: "11-20", number: 19 },
  { id: "1442.1.105.3401", index: 247, group: "11-20", number: 19 },
  { id: "1443.1.106.3401", index: 248, group: "11-20", number: 20 },
  { id: "713.12.107.3399", index: 249, group: "21-30", number: 21 },
  { id: "1444.1.107.3401", index: 250, group: "21-30", number: 21 },
  { id: "1445.1.108.3401", index: 251, group: "21-30", number: 22 },
  { id: "1810.1.108.3402", index: 252, group: "21-30", number: 22 },
  { id: "715.1.109.3399", index: 253, group: "21-30", number: 23 },
  { id: "1446.1.109.3401", index: 254, group: "21-30", number: 23 },
  { id: "1811.1.109.3402", index: 255, group: "21-30", number: 23 },
  { id: "716.10.110.3399", index: 256, group: "21-30", number: 24 },
  { id: "1447.1.110.3401", index: 257, group: "21-30", number: 24 },
  { id: "717.12.111.3399", index: 258, group: "21-30", number: 25 },
  { id: "1448.1.111.3401", index: 259, group: "21-30", number: 25 },
  { id: "718.12.112.3399", index: 260, group: "21-30", number: 26 },
  { id: "1449.1.112.3401", index: 261, group: "21-30", number: 26 },
  { id: "1814.1.112.3402", index: 262, group: "21-30", number: 26 },
  { id: "2179.1.112.3403", index: 263, group: "21-30", number: 26 },
  { id: "719.1.113.3399", index: 264, group: "21-30", number: 27 },
  { id: "719.11.113.3399", index: 265, group: "21-30", number: 27 },
  { id: "719.12.113.3399", index: 266, group: "21-30", number: 27 },
  { id: "1450.1.113.3401", index: 267, group: "21-30", number: 27 },
  { id: "1450.12.113.3401", index: 268, group: "21-30", number: 27 },
  { id: "2180.1.113.3403", index: 269, group: "21-30", number: 27 },
  { id: "720.1.114.3399", index: 270, group: "21-30", number: 28 },
  { id: "1451.1.114.3401", index: 271, group: "21-30", number: 28 },
  { id: "1451.1.114.3401", index: 272, group: "21-30", number: 28 },
  { id: "2181.1.114.3403", index: 273, group: "21-30", number: 28 },
  { id: "1452.1.115.3401", index: 274, group: "21-30", number: 29 },
  { id: "1452.12.115.3401", index: 275, group: "21-30", number: 29 },
  { id: "1817.1.11.115.3402", index: 276, group: "21-30", number: 29 },
  { id: "722.11.116.3399", index: 277, group: "21-30", number: 30 },
  { id: "722.12.116.3399", index: 278, group: "21-30", number: 30 },
  { id: "1453.1.116.3401", index: 279, group: "21-30", number: 30 },
  { id: "1453.12.116.3401", index: 280, group: "21-30", number: 30 },
  { id: "2183.1.116.3403", index: 281, group: "21-30", number: 30 },
  { id: "723.1.117.3399", index: 282, group: "31-40", number: 31 },
  { id: "1454.1.117.3401", index: 283, group: "31-40", number: 31 },
  { id: "1454.12.117.3401", index: 284, group: "31-40", number: 31 },
  { id: "1819.1.117.3403", index: 285, group: "31-40", number: 31 },
  { id: "724.11.118.3399", index: 286, group: "31-40", number: 32 },
  { id: "1455.12.118.3401", index: 287, group: "31-40", number: 32 },
  { id: "1820.1.118.3402", index: 288, group: "31-40", number: 32 },
  { id: "725.2.119.3399", index: 289, group: "31-40", number: 33 },
  { id: "1456.1.119.3401", index: 290, group: "31-40", number: 33 },
  { id: "1456.12.119.3401", index: 291, group: "31-40", number: 33 },
  { id: "2186.1.119.3403", index: 292, group: "31-40", number: 33 },
  { id: "726.3.120.3399", index: 293, group: "31-40", number: 34 },
  { id: "1457.1.120.3401", index: 294, group: "31-40", number: 34 },
  { id: "1457.12.120.3401", index: 295, group: "31-40", number: 34 },
  { id: "727.2.121.3399", index: 296, group: "31-40", number: 35 },
  { id: "727.11.121.3399", index: 297, group: "31-40", number: 35 },
  { id: "727.12.121.3399", index: 298, group: "31-40", number: 35 },
  { id: "1458.1.121.3401", index: 299, group: "31-40", number: 35 },
  { id: "1458.12.121.3401", index: 300, group: "31-40", number: 35 },
  { id: "2188.1.121.3403", index: 301, group: "31-40", number: 35 },
  { id: "728.1.122.3399", index: 302, group: "31-40", number: 36 },
  { id: "728.3.122.3399", index: 303, group: "31-40", number: 36 },
  { id: "1459.1.122.3401", index: 304, group: "31-40", number: 36 },
  { id: "729.2.123.3399", index: 305, group: "31-40", number: 37 },
  { id: "729.13.123.3399", index: 306, group: "31-40", number: 37 },
  { id: "1825.1.123.3402", index: 307, group: "31-40", number: 37 },
  { id: "2190.1.123.3403", index: 308, group: "31-40", number: 37 },
  { id: "730.2.124.3399", index: 309, group: "31-40", number: 38 },
  { id: "730.13.124.3399", index: 310, group: "31-40", number: 38 },
  { id: "2191.1.124.3403", index: 311, group: "31-40", number: 38 },
  { id: "731.2.125.3399", index: 312, group: "31-40", number: 39 },
  { id: "1462.12.125.3401", index: 313, group: "31-40", number: 39 },
  { id: "1827.1.125.3402", index: 314, group: "31-40", number: 39 },
  { id: "2192.11.125.3403", index: 315, group: "31-40", number: 39 },
  { id: "732.3.126.3399", index: 316, group: "31-40", number: 40 },
  { id: "732.12.126.3399", index: 317, group: "31-40", number: 40 },
  { id: "1463.1.126.3401", index: 318, group: "31-40", number: 40 },
  { id: "1828.1.126.3402", index: 319, group: "31-40", number: 40 },
  { id: "2193.1.126.3403", index: 320, group: "31-40", number: 40 },



  { id: "779.2.173.3398", index: 1, group: "80-90", number: 80 },
  
  // { id: "NEW_ID", index: 260, group: "31-40", number: 31 },
];

const ImgOlslmQ2: React.FC = () => {
  // Group images by 'group' and 'number'
  const groupedImages = imageData.reduce((acc, img) => {
    acc[img.group] = acc[img.group] || {};
    acc[img.group][img.number] = acc[img.group][img.number] || [];
    acc[img.group][img.number].push(img);
    return acc;
  }, {} as Record<string, Record<number, ImageData[]>>);

  const renderTreeNodes = () => (
    <TreeNode title="Q2" key="2-2-2" value="2-2-2" disabled>
      {Object.entries(groupedImages).map(([group, numbers]) => (
        <TreeNode
          title={group}
          key={`0-${group}`}
          value={`0-${group}`}
          disabled
          aria-label={`Image group ${group}`}
        >
          {Object.entries(numbers)
            .sort(([a], [b]) => Number(a) - Number(b))
            .map(([number, imgs]) => (
              <TreeNode
                title={number}
                key={`random0-${number}-${group}`}
                value={`random0-${number}-${group}`}
                disabled
                aria-label={`Image subgroup ${number}`}
              >
                {imgs.map((img, idx) => {
                  const image = loginImages.images[img.index];
                  return image ? (
                    <TreeNode
                      title={
                        <Tooltip title={img.id}>
                          <span>
                            <ImagePreview
                              src={image.url}
                              alt={`Image ${img.id}`}
                              onError={(e) => {
                                e.currentTarget.src = "https://via.placeholder.com/50";
                              }}
                            />
                            {img.id}
                          </span>
                        </Tooltip>
                      }
                      key={`image-${img.index}-${img.id}-${idx}`}
                      value={image.url}
                      imageUrl={image.url}
                      aria-label={`Image ${img.id}`}
                    />
                  ) : (
                    <TreeNode
                      title={`Missing image: ${img.id}`}
                      key={`missing-${img.id}-${idx}`}
                      value={`missing-${img.id}`}
                      disabled
                      aria-label={`Missing image ${img.id}`}
                    />
                  );
                })}
              </TreeNode>
            ))}
        </TreeNode>
      ))}
    </TreeNode>
  );

  return renderTreeNodes();
};

export default ImgOlslmQ2;